import { render } from "./ViewerSearch.vue?vue&type=template&id=9185a50e"
import script from "./ViewerSearch.vue?vue&type=script&lang=js"
export * from "./ViewerSearch.vue?vue&type=script&lang=js"

import "./ViewerSearch.vue?vue&type=style&index=0&id=9185a50e&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__